import React from "react";
import { Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import "./assets/style/style.scss";
import "./assets/style/color.scss";
import "./assets/style/fonts.scss";
import "./assets/style/heights.scss";
import "./assets/style/widths.scss";
import "./assets/style/responsive.scss";
import "./assets/style/custome.scss";

import PrivateRoutes from "./Screen/redux/Store/privateRoutes";
import Login from "./Screen/Auth/Login/Login";
import Home from "./Screen/Home/Home";
import Signup from "./Screen/Auth/Signup/Signup";
import ForgetPassword from "./Screen/Auth/ForgetPassword/ForgetPassword";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Lotteries from "./Components/Lotteries/Lotteries";
import Lottery from "./Screen/Lottery/Lottery";
import Result from "./Screen/Result/Result";
import CustomerWin from "./Screen/CustomerWin/CustomerWin";
import Card from "./Screen/Card/Card";
import { Add } from "@mui/icons-material";
import AddToCart from "./Screen/Card/Card";
import TicketSelect from "./Screen/TicketSelect/TicketSelect";



const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forget_password" element={<ForgetPassword />} />
      {/* <Route element={<PrivateRoutes />}> */}
      <Route path="/home" element={<Home />} />
      <Route path="/lottery" element={<Lottery />} />
      <Route path="/result" element={<Result />} />
      <Route path="/customer-winner" element={<CustomerWin />} />
      <Route path="/card" element={<AddToCart />} />
      <Route path="/ticket-select" element={<TicketSelect />} />
      {/* </Route> */}
    </Routes>
  );
};

export default AppRouter;
